<template>
    <div style="width:100%">


      <md-table v-model="paginatedtableData" :md-sort.sync="currentSort" :md-sort-order.sync="currentSortOrder" :md-sort-fn="customSort">
        <md-table-row style="max-height: 400px" slot="md-table-row"   slot-scope="{ item, index }"  md-selectable="single">
          <md-table-cell md-label="#"  md-numeric>{{ index+1 }}</md-table-cell>
        
          <md-table-cell md-label="IP" md-sort-by="ip">{{ item.ip }}</md-table-cell>
          <md-table-cell md-label="Message" md-sort-by="message">{{ item.message }}</md-table-cell>
          <md-table-cell md-label="Date" md-sort-by="createdAt">{{ item.createdAtFormat }}</md-table-cell>
          <md-table-cell md-label="User" md-sort-by="userId">{{ item.userData.firstName + ' ' + item.userData.lastName }}</md-table-cell>
          <!-- <md-table-cell md-label="Transaction" md-sort-by="transactionId">
            <md-button v-if="item.transactionId" class="md-icon-button" :to="'/show?transactionId='+item.transactionId" title="To transaction">
              <md-icon>visibility</md-icon>
            </md-button>
          </md-table-cell> -->



          <!-- <md-table-cell md-label="User Id" md-sort-by="id" md-numeric>{{ item.id }}</md-table-cell> -->
        </md-table-row>

      </md-table>

      <div class="md-layout md-gutter md-alignment-center-right" style="margin-top:15px; max-height: 400px;padding-right: 25px;">
        <span class="md-layout-item md-size-15">Rows per page:</span>
        <div class="md-layout-item md-size-10">
          <md-field>
            <md-select v-model="rowsPerPage" @md-selected="currentPage=1;updatePagination()">
              <md-option value="5">5</md-option>
              <md-option value="10">10</md-option>
              <md-option value="15">15</md-option>
              <md-option value="20">20</md-option>
            </md-select>
          </md-field>
        </div>

        <span class="md-layout-item md-size-10"> {{ (initialRow+1) + '-' + (finalRow) + ' of ' + (totalRows)}}</span>
        <div class="md-layout-item md-size-5">
          <md-button class="md-icon-button" @click="currentPage-=1;updatePagination()" :disabled="currentPage == 1">
            <md-icon>chevron_left</md-icon>
          </md-button>
        </div>
        <div class="md-layout-item md-size-5">
          <md-button class="md-icon-button" @click="currentPage+=1;updatePagination()" :disabled="currentPage == totalPages">
            <md-icon>chevron_right</md-icon>
          </md-button>
        </div>
      </div>

       
</div>

</template>

<script>
import axios from "axios";
import Vue from "vue";
import moment from 'moment'

  export default {
    data ()   {
      return {
        dateFormat: Vue.prototype.$generalConfiguration['dateFormat'],
        userDialogData:{},
        labelsRoles : ['Admin', 'Manager','Signee','Initial Approver', 'Final Approver'],
        roles : ['admin', 'manager','signee','initial', 'final'],
        rowsPerPage  : 10,
        currentPage : 1,
        totalPages: 1,
        initialRow: 1,
        finalRow: 1,
        totalRows: 1,
        selected: {},
        tableData: [],
        searchText : "",
        paginatedtableData: [],
        roleSelect: ['admin', 'manager','signee','initial', 'final'],
        role: null,
        currentSortOrder: 'desc',
        currentSort: 'ip'
      }
    },
    props: {
      searchFilters : {

      }
    },
    watch: {
      searchFilters: {
          // the callback will be called immediately after the start of the observation
          immediate: true, 
          handler (newData,oldval) {
            if(newData != oldval && typeof newData != 'undefined' && typeof newData['userId'] != 'undefined'){
              
              this.findMatches(newData)
            }
          }
        },
    },
    methods: {        
      customSort () {
          return this.tableData.sort((a, b) => {
              const sortBy = this.currentSort;
              var valA = JSON.stringify(a[sortBy]);
              var valB = JSON.stringify(b[sortBy]);
              if (this.currentSortOrder !== 'desc') {
                  return valA.localeCompare(valB)
              }
              return valB.localeCompare(valA);
          }).filter((element,index) => {
              element.createdAtFormat = moment(element.createdAt).format(this.dateFormat);
              return index >= this.initialRow &&  index < this.finalRow
          })
      },


      findMatches(newData){
        let loader = this.$loading.show({
                'loader' : 'dots' ,
                'color': '#e94e1b', 
                'backgroundColor': '#6B6B6B', 
                'height' : 155, 
                'width' : 155 
                });
        axios({
          method: "post",
          url: "/trail/filter",
          baseURL: process.env.VUE_APP_BASE_API,
          headers: {
            Authorization: "Bearer " + Vue.prototype.$userData.tokens.access.token,
          },
          data :{...newData}
        })
        .then((response) => {
          loader.hide()
          this.tableData= response.data;
          this.currentPage = 1; 
              this.updatePagination()
        })
        .catch(function () {
          loader.hide()
          console.log("FAILURE!!");
        });

      },

      updatePagination () {     
        
        this.totalRows = this.tableData.length;

        this.totalPages = Math.ceil( this.totalRows / this.rowsPerPage);
        this.initialRow = (this.currentPage - 1 )  * ( this.rowsPerPage);
        this.finalRow = (this.currentPage )  * ( this.rowsPerPage);
        if( this.finalRow > this.totalRows) {
          this.finalRow = this.totalRows;
        }
        this.paginatedtableData = this.customSort() 
      },

    },
    mounted(){
      this.role =Vue.prototype.$userData.user.role[0];
 
        
    },
    computed :{
    }
  }
</script>

<style lang="scss" >
    
  .md-table + .md-table {
    margin-top: 16px
  }
.dialog-content{
    margin: 20px; 
    padding: 0px;
}

.md-dialog-title{
    background-color:#e94e1b; 
    margin: 0px; 
    padding: 20px; 
    color: white
}

.md-selected-row{
  background-color: #dddddd !important;
}
.md-progress-bar.md-determinate.md-theme-default{
  background-color: #8b7b7b !important;
  height: 8px;

}
.md-progress-bar.md-theme-default.md-determinate.md-danger-date .md-progress-bar-fill {
    background-color: #97261e !important;
}
.md-progress-bar.md-theme-default.md-determinate.md-alert-date .md-progress-bar-fill {
    background-color: #d86901 !important;
}

</style>